export default __webpack_public_path__ + "static/NotoSans-Italic-02294dd982a747d223ad28a85efe654b.ttf";